import { Component, output, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UmssIconComponent } from '../icon/icon.component';
import { UmssButtonComponent } from '../button/button.component';
@Component({
  selector: 'umss-who-are-you',
  imports: [UmssButtonComponent, RouterLink, UmssIconComponent],
  templateUrl: './who-are-you.component.html',
  styleUrl: './who-are-you.component.scss'
})
export class WhoAreYouComponent {
  getStarted = output<'corporation' | 'facility'>();

  selection = signal<'corporation' | 'facility' | undefined>(undefined);

  onGetStarted(): void {
    const selection = this.selection();
    if (!selection) return;
    this.getStarted.emit(selection);
  }

  onSelectionChange(selector: 'corporation' | 'facility'): void {
    this.selection.set(selector);
  }
}
